import translate from "../../../i18n/translate";

export default function Loader(): JSX.Element {
  return (
    <div className="loader -fullscreen">
      <div className="content content-loader">{translate("app.loading")}</div>
    </div>
  );
}
